(function () {

    'use strict';

    angular.module('Services').factory('zonePostcodeTableService', zonePostcodeTableService);

    zonePostcodeTableService.$inject = [
        'Carrier',
        'TableLiteFactory',
        'toastr',
        'ConfirmationModalFactory',
        '$uibModal'
    ];

    function zonePostcodeTableService(
        Carrier,
        TableLiteFactory,
        toastr,
        ConfirmationModalFactory,
        $uibModal
    ) {
        return function (zoneDetails, carrierProfileId) {
            const deletePostCode = new ConfirmationModalFactory({}, {
                message: 'messages.warning.deletePostCode.MESSAGE',
                code: 'messages.warning.deletePostCode.CODE'
            });

            let tableStructure = {
                optionAddOns: {
                    buttons: [{
                        class: 'btn-success',
                        label: 'Import',
                        onClick: () => {
                            $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                windowClass: 'r-c-p-modal',
                                templateUrl: '/templates/pages/carriers/additionals/importZoneModal.html',
                                controller: function ($uibModalInstance) {
                                    let vm = this;
                                    vm.downloadTemplate = downloadTemplate;
                                    vm.dismiss = dismiss;
                                    vm.importCSV = importCSV;
                                    vm.columnLabels = [{
                                        name: 'POSTCODE',
                                        value: 'CODE'
                                    }, {
                                        name: 'NAME',
                                        value: 'NAME'
                                    }, {
                                        name: 'STATE',
                                        value: 'STATE'
                                    }];
                                    vm.columnValues = [
                                        { name: 'Column 1', value: 1, sampleVal: '2530' },
                                        { name: 'Column 2', value: 2, sampleVal: 'Horsley' },
                                        { name: 'Column 3', value: 3, sampleVal: 'New South Wales' },

                                    ];
                                    vm.columns = [...vm.columnValues.map((val, index) => {
                                        return { value: angular.extend(angular.copy(val), { label: vm.columnLabels[index] }) };
                                    })];
                                    vm.columnsRaw = angular.copy(vm.columns);

                                    function getOrderedCol(field) {
                                        return vm.columns.map(column => {
                                            return vm.columnsRaw[column.value.value - 1].value[field];
                                        });
                                    }
                                    function getMappedFields() {
                                        return getOrderedCol('label').map(col => col.value).toString();
                                    }
                                    function getMappedValues() {
                                        return getOrderedCol('sampleVal').toString()
                                    }
                                    function dismiss() {
                                        $uibModalInstance.dismiss();
                                    }
                                    function downloadTemplate() {
                                        let headers = getMappedFields();
                                        let sampleBody = getMappedValues();
                                        download(headers + "\r\n" + sampleBody, "import-postcode-template.csv", "text/csv");
                                    }
                                    function importCSV(form) {
                                        form.$setSubmitted();
                                        if (form.$invalid) {
                                            return false;
                                        }

                                        let postCodeDetails = {
                                            id: zoneDetails.carrierProfile.id,
                                            zoneId: zoneDetails.id,
                                            countryName: zoneDetails.countryName
                                        }
                                        if (vm.file) {
                                            vm.isImporting = true;
                                            Carrier.uploadCarrierPostCode(postCodeDetails, data => {
                                                vm.isImporting = false;
                                                toastr.success('Import draft successfully created!');
                                            }, err => {
                                                vm.isImporting = false;
                                                toastr.error('Creating import draft failed!', err.message);
                                            }, vm.file, evt => {
                                                vm.progressData = 100.0 * evt.loaded / evt.total;
                                            });
                                        }
                                    }
                                },
                                controllerAs: 'vm',
                            })
                        }
                    },
                    {
                        class: 'btn-primary',
                        label: 'Export',
                        onClick: () => {
                            let vm = this;
                            const columnValues = []
                            let selected = tableStructure.data.filter(item => {
                                return item.isSelected;
                            });
                            if (!selected.length) {
                                toastr.warning('Please select postcodes to Export');
                                return;
                            }

                            vm.columnLabels = [{
                                name: 'POSTCODE',
                                value: 'CODE'
                            }, {
                                name: 'NAME',
                                value: 'NAME'
                            }, {
                                name: 'STATE',
                                value: 'STATE'
                            }];
                            vm.columnValues = [
                                { name: 'Column 1', value: 1, sampleVal: '2530' },
                                { name: 'Column 2', value: 2, sampleVal: 'Horsley' },
                                { name: 'Column 3', value: 3, sampleVal: 'New South Wales' },

                            ];
                            for (let i = 0; i < selected.length; i++) {
                                columnValues.push(
                                    { code: selected[i].postcode, name: selected[i].postcodeName, state: selected[i].stateName },

                                );
                            }
                            vm.columns = [...vm.columnValues.map((val, index) => {
                                return { value: angular.extend(angular.copy(val), { label: vm.columnLabels[index] }) };
                            })];
                            vm.columnsRaw = angular.copy(vm.columns);
                            function getOrderedCol(field) {
                                return vm.columns.map(column => {
                                    return vm.columnsRaw[column.value.value - 1].value[field];
                                });
                            }
                            function getMappedFields() {
                                return getOrderedCol('label').map(col => col.value).toString();
                            }
                            function getMappedValues() {
                                let line = '';
                                for (let i = 0; i < columnValues.length; i++) {
                                    let str = `${columnValues[i].code},${columnValues[i].name},${columnValues[i].state}`
                                    line += str + '\r\n';
                                }
                                return line
                            }

                            let headers = getMappedFields();
                            let sampleBody = getMappedValues();

                            download(headers + "\r\n" + sampleBody, "export-postcode-template.csv", "text/csv");

                        }
                    },
                    {
                        class: 'btn-danger',
                        label: 'Delete Selected',
                        onClick: () => {
                            let selected = tableStructure.data.filter(item => {
                                return item.isSelected;
                            });
                            if (selected.length == 0) {
                                toastr.warning('Please select postcodes to delete');
                                return false;
                            } else {
                                deletePostCode.getInstance().result.then(cond => {
                                    if (cond) {
                                        Carrier.removeZonePostcode({
                                            carrierProfileId: carrierProfileId,
                                            zoneId: zoneDetails.id
                                        }, selected.map(postcode => postcode.id),
                                            data => {
                                                tableActions.resetFilters();
                                            }, error => {
                                                toastr.error('Unable to delete postcode(s)', error.message);
                                            });
                                    }
                                });
                            }
                        }
                    }]
                },
                config: {
                    noExtract: true,
                    noTopOptions: false
                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    filter: {
                        type: 'checkbox'
                    }
                }, {
                    label: 'POSTCODE',
                    viewName: 'postcode',
                    filterName: 'code',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'NAME',
                    viewName: 'postcodeName',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'STATE',
                    viewName: 'stateName',
                    filterName: 'stateName',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: header => {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: [],
                onInit: function () {
                    if (!zoneDetails.newZone && zoneDetails.id !== 'new')
                        sendRequest({});
                    else
                        tableActions.initializeTableData({});
                }
            };

            const tableActions = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getZonePostcodes,
                    callbackFormat: ['id', 'success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        if (err)
                            toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'code,desc'
                    },
                    paramId: {
                        zoneId: zoneDetails.id,
                        carrierProfileId: carrierProfileId
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                if (!data)
                    return false;
                angular.forEach(data.content, function (row) {
                    row.postcode = row.code || 'N/A';
                    row.postcodeName = row.name || 'N/A';
                    row.stateName = angular.getObjVal(row, 'state.name') || 'N/A';
                    tableStructure.data.push(row);
                })
            }

            this.tableData = tableStructure;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/zonePostcodeTableService.js